import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FlaggedFund.css'
// import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import ReactTooltip from 'react-tooltip'

@CSSModules(Styles)
export default class FlaggedFund extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    weight: PropTypes.number.isRequired,
    totalFunds: PropTypes.number,
    isFamily: PropTypes.bool
  }
  constructor(props){
    super(props)
  }
  render() {
    function renderStatCount(tip,count,label){
      return <div styleName={'stat'} data-multiline={true} data-effect={'solid'} data-tip={tip}>
        <div styleName='stat-count-wrapper'>
          <div styleName='stat-count'>{ count }</div>
        </div>
        <div styleName='stat-label'> {label}</div>
      </div>
    }
    const type = (this.props.isFamily)? 'family' : 'fund'
    return (
      <div styleName='stats-wrapper'>
        <div styleName='stats'>
          { (this.props.isFamily)?
            renderStatCount('Number of funds analyzed from this '+type,
              format.number(this.props.totalFunds), 'FUNDS ANALYZED' ) : null
          }
          {renderStatCount('Total number of deforestation-risk<br/>stocks we found in this '+type,
            format.number(this.props.count), 'holdings flagged' )}
          {renderStatCount('Total percent of the '+type+'\'s long-position assets<br/>invested in deforestation-risk stocks',
            format.perc(this.props.weight), 'of assets flagged' )}
        </div>
        <ReactTooltip />
      </div>
    )
  }
}

